import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientDocuments = (state, patientId) =>
  allModelsSelector(state, 'PatientDocument', (document) => document.patientId === patientId);
